'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var UPDATE_ERROR = exports.UPDATE_ERROR = 'tq-plus-admin/errors/UPDATE_ERROR';

var updateError = exports.updateError = function updateError(error) {
    return {
        type: UPDATE_ERROR,
        error: error
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/errors.js
// module id = 1660
// module chunks = 0